<template>
  <div>
    <v-data-table
      v-model="selected"
      :show-select="totaleMovimenti > 0"
      item-key="_id"
      :headers="headers"
      :items="movimenti"
      :options.sync="options"
      :server-items-length="totaleMovimenti"
      :loading="loading"
      class="elevation-1"
      @click:row="clickRow"
      @dblclick:row="dblclickRow"
      :disable-sort="true"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 15, 50, 100]
      }"
      :single-expand="singleExpand"
      :expanded.sync="expanded"
      :show-expand="false"
    >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>Movimenti</v-toolbar-title>
<!--    <v-divider class="mx-4" inset vertical></v-divider> -->
        <v-spacer></v-spacer>
        <v-btn color="primary" dark class="mb-2" @click="onNuovoMovimento">Nuovo Movimento</v-btn>
<!--         <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="text-h5">Confermi cancellazione movimento?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="deleteItemConfirm">SI</v-btn>
              <v-btn color="blue darken-1" text @click="closeDelete">NO</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog> -->
        <dialog-errore :show="dialogErrore" :title="errorTitle" :message="errorMessage" @dialogConfirm="dialogErrore = false"/>
        <dialog-stampa
          :show="dialogStampa"
          title="Stampa Etichette"
          confirmText="Stampa"
          cancelText="Annulla"
          :totaleEtichette="totaleEtichette"
          :isStampaEtichette="true"
          :isModuloA4="isModuloA4"
          @dialog-print="onDialogPrint"
          @dialog-cancel="onDialogCancel"
        />
      </v-toolbar>
      <filtri @ricerca="onRicerca"/>
    </template>
    <template v-slot:[`item.data`]="{ item }">
      <!-- {{ item.riferimento.data && item.riferimento.data.substring(0, 22) | date }} -->
      {{ item.data | date }}
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon small class="mr-2" @click="editItem(item)" v-bind="attrs" v-on="on">mdi-archive-eye-outline</v-icon>
        </template>
        <span>Dettaglio del movimento</span>
      </v-tooltip>
<!--       <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon small class="mr-2" @click="duplicateItem(item)" v-bind="attrs" v-on="on">mdi-content-duplicate</v-icon>
        </template>
        <span>Duplica il movimento</span>
      </v-tooltip> -->
<!--       <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon small @click="deleteItem(item)" v-bind="attrs" v-on="on">mdi-delete</v-icon>
        </template>
        <span>Cancella il movimento</span>
      </v-tooltip> -->
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="getDataFromApi">Ricarica</v-btn>
    </template>
<!--     <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length" >
        <v-tabs dense v-model="tab">
          <v-tab>Recapiti{{item.name}}</v-tab>
          <v-tab>Contatti</v-tab>
          <v-tab>Cards</v-tab>
          <v-tab>Dati amministrativi</v-tab>
          <v-tab>Ordini</v-tab>
          <v-tab>Fatture</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item v-for="rc in item.recapiti" :key="rc">
            <recapiti :dati="rc"/>
          </v-tab-item>
        </v-tabs-items>
      </td>
    </template>   -->
    </v-data-table>
    <speed-dial @comando="onSpeedDialogComando"/>
  </div>
</template>

<script>
  import { dynamicSortMultiple } from '@/components/helpers.js'
  import _ from 'lodash'
  import DialogErrore from '@/components/dialogErrore'
  import DialogStampa from '@/components/dialogStampa'
  import SpeedDial from './speedDial.vue'
  import Filtri from './testate_filtri'
  import configurazioni from '@/services/configurazioniService.js'
  import moment from 'moment'
  import movimenti from '@/services/movimentiService.js'
  import etichetteService from '@/services/etichetteService.js'
  import magazzino from '@/services/magazzinoService.js'
  const labelsPath = window.appConfig.VUE_APP_MOL_S_LABELS

  export default {
    components: {
      DialogErrore,
      Filtri,
      SpeedDial,
      DialogStampa
      // Recapiti
    },
    data () {
      return {
        totaleMovimenti: 0,
        movimenti: [],
        selected: [],
        loading: true,
        options: {},
        headers: [
          { text: 'Causale', value: 'causale', align: 'start'},
          { text: 'Nominativo', value: 'c_nominativo' },
          { text: 'Data', value: 'data' },
          { text: 'Riferimento', value: 'riferimento.id' },
          { text: 'Tipo', value: 'riferimento.tipo' },
          { text: 'Magazzino', value: 'magazzino' },
          { text: 'Actions', value: 'actions', sortable: false },
          { text: '', value: 'data-table-expand' }
        ],
        expanded: [],
        singleExpand: false,
        dialogErrore: false,
        dialogDelete: false,
        dialogStampa: false,
        editedIndex: -1,
        editedItem: null,
        defaultItem: null,
        filtri: null,
        tab: null,
        pathEtichettePrefix: '',
        usaQtaAnagrafica: false,
        // salta: 0,
        tipoStampa: '',
        report: '',
        isModuloA4: false,
        errorTitle: 'Errore aggiornamento Movimento',
        errorMessage: ''
      }
    },
  created() {
      this.pathEtichettePrefix = window.appConfig.VUE_APP_MOL_API_GATEWAY || ''
  },
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nuovo Movimento' : 'Modifica Movimento'
      },
      movimentiSaved() {
        return this.$store.getters['movimenti/saved']
      },
      testateAperta() {
        return this.$store.getters['movimenti/page'] === 'testate'
      },
      refreshList() {
        return this.$store.getters['movimenti/refreshTestata']
      },
      movimentiSorted() {
        const els = this.movimenti
        const elSorted = els.sort(dynamicSortMultiple('_id'))
        return elSorted
      },
      totaleEtichette() {
        const elSel = this.selected
        if (elSel.length > 0) {
          const totaleAnagrafica = _.sum(elSel.map(x => x.qtaAnagrafica))
          const totaleMovimenti = _.sum(elSel.map(x => x.qtaMovimenti))
          return { totaleAnagrafica, totaleMovimenti }
        } else {
          return { totaleAnagrafica: 0, totaleMovimenti: 0 }
        }
      }
    },
    watch: {
      options: {
        async handler () {
          await this.getDataFromApi()
        },
        deep: true
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
      async movimentiSaved(value) {
        if (value && this.testateAperta) {
          await this.save()
        }
      },
      async refreshList(value) {
        if (value) {
          await this.getDataFromApi()
          this.$store.commit('movimenti/CLEAR_REFRESH', 'testata')
        }
      }
    },
    async created() {
      await this.getDefaultItem()
/*       this.defaultItem = await movimenti.getModello('xxx')
      this.defaultItem.data = new Date() */
    },
    async mounted () {
      await this.getDataFromApi()
    },
    methods: {
      async getDefaultItem() {
        this.defaultItem = await movimenti.getModello('xxx')
        this.defaultItem.data = new Date()
      },
      async onRicerca(filtri) {
        this.filtri = filtri
        this.options.page = 1
        await this.getDataFromApi()
      },
      async getDataFromApi () {
        try {
          this.loading = true
          /*
            Versione per dettaglio riga
            const data = await magazzino.getFilteredMovements(this.filtri, this.options)
            this.movimentiRaw = data && data.total_rows > 0 ? data.rows : [] // TODO: valida per la versione modificata. Da adeguare
          */
          const data = await movimenti.getFilteredMovementHeaders(this.filtri, this.options)
          // this.movimentiRaw = data && data.total_rows > 0 ? data.rows.map(x => x.doc) : []
          this.movimentiRaw = data && data.total_rows > 0 ? data.rows : []
          this.movimenti = this.datiVisualizzazione(this.movimentiRaw)
          // this.movimenti = data && data.total_rows > 0 ? data.rows : []
          this.totaleMovimenti = data.total_rows
        } catch(err) {
          this.movimenti = []
          this.totaleMovimenti = 0
        } finally {
          this.loading = false
        }
      },
      async onNuovoMovimento() {
        this.editedIndex = -1
        await this.getDefaultItem()
        this.editedItem = Object.assign({}, this.defaultItem)
        this.$store.commit('movimenti/SET_MOVIMENTO', this.editedItem)
        this.$store.commit('SET_RIGHT_DRAWER_READ_ONLY', false)
        this.$store.commit('SET_RIGHT_DRAWER', true)
      },
      editItem (item) {
        // Siamo nella testata --> l'icona di modifica porta al dettaglio dei movimenti
        this.editedIndex = this.movimenti.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.$store.commit('movimenti/SET_CHIAVE', this.editedItem)
        this.$emit('apriDettaglio', this.editedItem)
      },
/*       duplicateItem(item) {
        this.editedIndex = -1
        this.editedItem = Object.assign({}, item)
        this.editedItem._id = ''
        delete this.editedItem._rev
        this.$store.commit('movimenti/SET_MOVIMENTO', this.editedItem)
        this.$store.commit('SET_RIGHT_DRAWER_READ_ONLY', false)
        this.$store.commit('SET_RIGHT_DRAWER', true)
      }, */
/*       deleteItem (item) {
        this.editedIndex = this.movimenti.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      }, */

/*       async deleteItemConfirm () {
        this.movimenti.splice(this.editedIndex, 1)
        // TODO: ATTENZIONE VA VERIFICATO CHE NON ABBIA STORIA
        if (!await movimenti.cancellaMovimento(this.editedItem)) {
          this.dialogErrore = true
        }
        this.closeDelete()
      }, */

      close () {
        this.$store.commit('SET_RIGHT_DRAWER', false)
        this.$nextTick(() => {
          this.editedItem = null // Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      async save () {
        this.$store.commit('movimenti/CLEAR_MOVIMENTO_SAVED')
        this.editedItem = this.$store.getters['movimenti/movimento']
        if (this.editedIndex > -1) {
          this.editedItem = this.deleteDatiVisualizzazione(this.editedItem)
          Object.assign(this.movimenti[this.editedIndex], this.editedItem)
          if (!await movimenti.aggiornaMovimento(this.editedItem)) {
            this.dialogErrore = true
            return
          }
        } else {
          this.editedItem = this.deleteDatiVisualizzazione(this.editedItem)
          this.movimenti.push(this.editedItem)
          if (!await magazzino.creaMovimenti(this.editedItem)) {
            this.dialogErrore = true
            return
          }
        }
        this.close()
        // va fatto il refresh della lista per prendere gli aggiornamenti
        await this.getDataFromApi()
      },
      erroreConfirm() {
        this.dialogErrore = false
      },
      clickRow(item, options) {

      },
      dblclickRow(event, options) {
        const item = options.item
        this.editItem (item)
/*         this.editedIndex = this.movimenti.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.$store.commit('movimenti/SET_MOVIMENTO', this.editedItem)
        this.$store.commit('SET_RIGHT_DRAWER_READ_ONLY', true)
        this.$store.commit('SET_RIGHT_DRAWER', true) */
      },
      datiVisualizzazione(movimenti) {
        const elaborati = movimenti.map(el => {
          let nominativo = ''
         // const nominativo = (el.anagrafica.fornitore && el.anagrafica.fornitore.descrizione) || (el.anagrafica.cliente && el.anagrafica.cliente.descrizione)
          if (el.anagrafica) {
            nominativo = _.get(el, 'anagrafica.fornitore.descrizione') || _.get(el, 'anagrafica.fornitore.ragioneSociale') || _.get(el, 'anagrafica.fornitore.codice') ||
                        _.get(el, 'anagrafica.cliente.descrizione') || _.get(el, 'anagrafica.cliente.ragioneSociale') || _.get(el, 'anagrafica.cliente.codice') || ''
          }
          return { ...el, c_nominativo: nominativo }
        })
        return elaborati
      },
      deleteDatiVisualizzazione(movimento) {
        let locMovimento = {...movimento}
        delete locMovimento.c_nominativo
        delete locMovimento.appoggio
        return locMovimento
      },
      async onSpeedDialogComando(comando, payload) {
        switch (comando) {
          case 'stampa-etichette':
            const impostazioni = await configurazioni.getConfigurazione('display_generale', 'etichette')
/*             this.tipoStampa = impostazioni.tipo
            this.report = impostazioni.report
            this.isModuloA4 = impostazioni.tipo === 'pdf' */
            this.dialogStampa = true
            break
          default:
            break
        }
      },
      onDialogCancel() {
        this.dialogStampa = false
      },
      async onDialogPrint(usaQtaAnagrafica, salta, tipoStampa, report) {
        this.usaQtaAnagrafica = usaQtaAnagrafica
        // this.salta = salta
        this.dialogStampa = false
        const tipoQuantita = this.usaQtaAnagrafica ? 'anagrafica' : 'movimento'
        const movimenti = this.selected
        for (let mm of movimenti) {
          const filtriAggiuntivi = [{
            applicazione: 'movimenti',
            chiave: 'riferimento.id',
            testo: mm.riferimento.id
          }]
          const parametri = {
            articoli: true,
            filtri: filtriAggiuntivi,
            gruppi: [],
            tipoQuantita
          }
          const filtro = {
            start: moment(mm.data).startOf('day').format('YYYYMMDD'),
            end: moment(mm.data).endOf('day').format('YYYYMMDD')
          }
          const filtroElementi = { filtro, parametri }
          const src = `${labelsPath}/${tipoStampa}/${report}?elm=${btoa(JSON.stringify(filtroElementi))}${salta ? '&sk=' + salta : ''}${tipoQuantita ? '&tpq=' + tipoQuantita : ''}`
          const printResult = await etichetteService.stampaDiretta(tipoStampa, src)
          if (printResult.status && printResult.status === 'error') {
            this.errorTitle = ' Errore stampa etichette'
            this.errorMessage = printResult.error
            this.dialogErrore = true
          }
        }
        this.annullaSelezione()
      },
      annullaSelezione() {
        while(this.selected.length > 0) { this.selected.pop() }
      }
    }
  }
</script>

<style lang="scss">
  tr.v-data-table__expanded__content  { // TODO: Solo su questa pagina !
    box-shadow: none !important;
  }

</style>
